<template>
  <nav>
    <ul>
      <li>
        <a
          :class="{ active: $route.name === 'home' }"
          @click.prevent="$router.push({ name: 'home' })"
          >{{ $t("nav.home") }}</a
        >
      </li>
      <li>
        <a
          :class="{ active: $route.name === 'resources' }"
          @click.prevent="$router.push({ name: 'resources' })"
          >{{ $t("nav.resources") }}</a
        >
      </li>
      <li>
        <a
          :class="{ active: $route.name === 'about' }"
          @click.prevent="$router.push({ name: 'about' })"
          >{{ $t("nav.about") }}</a
        >
      </li>
      <li>
        <a
          :class="{ active: $route.name === 'team' }"
          @click.prevent="$router.push({ name: 'team' })"
          >{{ $t("nav.team") }}</a
        >
      </li>
      <li>
        <a
          :class="{ active: $route.name === 'research' }"
          @click.prevent="$router.push({ name: 'research' })"
          >{{ $t("nav.research") }}</a
        >
      </li>
      <li>
        <a
          :class="{ active: $route.name === 'contact' }"
          @click.prevent="$router.push({ name: 'contact' })"
          >{{ $t("nav.contact") }}</a
        >
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: "LabNav",
};
</script>

<style scoped>
nav {
  background: #004080;
  padding: 10px 0;
}
nav ul {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 0 40px;
  list-style: none;
  margin: 0;
}
nav li {
  flex: 1 1 auto;
  text-align: center;
  margin: 5px 0;
  position: relative;
}
nav a {
  color: #fff;
  font-weight: bold;
  text-decoration: none;
  padding: 10px 0;
  display: block;
  transition: 0.3s;
  cursor: pointer;
}
nav a:hover {
  color: #ffd700;
  transform: scale(1.05);
}
nav a.active {
  color: #ffd700;
}
nav a:after {
  content: "";
  position: absolute;
  width: 0;
  height: 2px;
  bottom: 5px;
  left: 50%;
  background: #ffd700;
  transform: translateX(-50%);
  transition: 0.3s;
}
nav a:hover:after {
  width: 80%;
}
@media (max-width: 992px) {
  nav ul {
    padding: 0 20px;
  }
}
@media (max-width: 576px) {
  nav ul {
    flex-direction: column;
    padding: 0 10px;
  }
  nav li {
    width: 100%;
  }
}
</style>
